export default __webpack_public_path__ + "static/media/user-circle.92e33ea1.svg";